import React from 'react';
import { cn } from '~/helpers/utils';

type ReviewReplyAvatarProp = {
  className?: string;
  logo: string;
  name: string;
};

const ReviewReplyAvatar: React.FC<ReviewReplyAvatarProp> = ({
  className, 
  logo, 
  name,
}) => {
  return (
    <div className={cn('w-8 h-8 rounded-full bg-white relative overflow-hidden border border-stone-200', className)}>
      <img
        src={logo}
        alt={`Logo van ${name}`}
        className="absolute top-0 left-0 object-cover w-8 h-8"
      />
    </div>
  );
};

export default ReviewReplyAvatar;